module.exports = __webpack_public_path__ + "img/empty.62faa4ef.png";